module.exports = __webpack_public_path__ + "static/media/plus_dollar.40a2b8ef.svg";